import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        searchStream: {
            xs: 'rechercher',
            sm: 'rechercher une entreprise'
        },
        useSearchCompanyFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
        companies: 'entreprises',
        newCompany: 'nouvelle entreprise',
        updateCompany: 'modification',
        enableCompany: 'activer l\'entreprise ...',
        enableCompanyText: [
            'Vous êtes sur le point d\'activer l\'entreprise {label}.'
        ],
        disableCompany: 'désactiver l\'entreprise ...',
        disableCompanyText: [
            'Vous êtes sur le point de désactiver l\'entreprise {label}.'
        ],
        newSubsidiary: 'nouvelle filiale',
        subsidiary: 'filiale',
        callCenter: 'centre d\'appel',
        newAgency: 'nouveau portefeuille',
        updateAgency: 'modification',
        deleteAgency: 'supprimer le portefeuille ...',
        deleteAgencyText: [
            'Vous êtes sur le point de supprimer le portefeuille {label}.',
            'Cette action est irréversible.'
        ],
        disableUser: 'désactiver l\'utilisateur ...',
        disableUserText: [
            'Vous êtes sur le point de désactiver l\'utilisateur {login}.'
        ],
        upgradePremiumAccount: 'souscrire au compte prémium ...',
        upgradePremiumAccountText: [
            'Vous êtes sur le point de souscrir au compte prémium pour l\'entreprise {label}.'
        ],
        downgradePremiumAccount: 'révoquer le compte prémium ...',
        downgradePremiumAccountText: [
            'Vous êtes sur le point de révoquer le compte prémium de l\'entreprise {label}.'
        ],
        upgradeStandardAccount: 'souscrire au compte standard ...',
        upgradeStandardAccountText: [
            'Vous êtes sur le point de souscrir au compte standard pour l\'entreprise {label}.'
        ],
        job: 'poste',
        addAgency: 'ajouter un portefeuille',
        agency: 'portefeuille',
        agencies: 'portefeuilles',
        associateDissociateAgencies: 'modifier les portefeuilles',
        associateDissociatePatrimonies: 'modifier les patrimoines',
        downgradeExecutiveToPatrimonyManager: 'transformer en compte gestionnaire',
        newUser: 'nouvel utilisateur',
        updateUser: 'modification',
        users: 'utilisateurs',
        user: 'utilisateur',
        patrimony: 'patrimoine',
        tickets: 'tickets',
        synthesis: 'synthèse',
        subsidiaries: 'filiales',
        documents: 'documents',
        providers: 'fournisseurs',
        email: 'email',
        phone: 'téléphone',
        fax: 'fax',
        login: 'email',
        updateLogin: 'modifier le login',
        companyTypeEnum: {
            clientAccount: 'entreprise',
            clientAccountHolding: 'holding',
            callCenter: 'centre d\'appel'
        },
        referenceCompanyCmdTypeEnum: {
            createClientAccount: 'entreprise',
            createClientAccountHolding: 'holding',
            createCallCenter: 'centre d\'appel'
        },
        referenceUserCmdTypeEnum: {
            referenceCallCenterUser: 'utilisateur',
            referenceCallCenterOperator: 'opérateur',
            referenceExecutive: 'cadre',
            referenceClientAccountManager: 'administrateur',
            referencePatrimonyManager: 'gestionnaire',
        },
        userTypeEnum: {
            callCenterUser: 'utilisateur',
            callCenterOperator: 'opérateur',
            executive: 'cadre',
            clientAccountManager: 'administrateur',
            patrimonyManager: 'gestionnaire',
        },
        billingType: 'type de compte',
        billingTypeEnum: {
            standardAccount: 'compte standard',
            premiumAccount: 'compte prémium',
            sponsoredAccount: 'compte sponsorisé'
        },
        sendActivationEmail: 'renvoyer l\'email d\'activation',
        activationEmailSent: 'un email a été envoyé',
        userActive: 'Comptes activés',
        userInactive: 'Comptes désactivés',
        agencyActive: 'Portefeuilles activés',
        agencyInactive: 'Portefeuilles désactivés',
        identifyCompany: 'identification',
        siret: 'siret',
        ticketUidGeneratorPrefix: 'préfix',
        ticketUidGeneratorPrefixText: 'Le préfix doit comporter une à trois lettres',
        acknowledgeTicketUidGenerator: 'j\'ai pris connaissance du fait que le format des numéros de ticket sera modifié à partir de maintenant',
        ticketOpenedNotifications: 'recevoir un email lors de la création d\'un ticket',
        daybookNotifications: 'recevoir la main courante',
        simplifiedRequestOpenedNotifications: 'recevoir un email lors de la création d\'une demande simplifiée',
        reportPdfAgency: 'Télécharger le rapport PDF',
        reportingAgency: 'Téléchargement en cours',
        workflows: 'processus',
        openingticketpurposeref: 'Raison d\'ouverture',
        parameters: 'paramètres',
        openingticketinstructions: 'instructions',
        satisfactioncampaigns: 'satisfaction',
        qualifCriterias: 'arbres qualification',
        criteriaref: 'critères',
        contextualcommentref: 'Commentaires',
        notifications: 'Notifications'
    }
}

export default {
    ...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/company/i18n.js